import { MouseEvent, useState } from 'react';
import { IProjectItem } from 'common/types/projects';
import Lightbox from 'yet-another-react-lightbox';

import 'yet-another-react-lightbox/styles.css';

export const useProjectLightBox = ({ project }: { project?: IProjectItem }) => {
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number | undefined>(undefined);

  const slides = (() => {
    const a = project?.heroImage?.src ? [{ src: project?.heroImage.src || '' }] : [];
    project?.sections?.forEach(section => {
      if (section.type === 'sectionImage') {
        section.value?.forEach(image => {
          if (image?.value?.src) {
            a.push({ src: image.value.src });
          }
        });
      }
    });
    return a;
  })();

  const openLightBox = (src: string) => (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const index = slides.findIndex(slide => slide.src === src);
    setOpen(true);
    setCurrentIndex(index);
  };

  return {
    openLightBox,
    renderLightbox: () => (
      <Lightbox index={currentIndex} open={open} close={() => setOpen(false)} slides={slides} />
    ),
  };
};
